import React from 'react'
import { IssuingListUser } from './issuingListUser'

export const IssuingListUsers = () => {
  return (
    <IssuingListUser />
  )
}
